import React, {Component} from "react";
import Api from "../../api/Api";
import './Academy.css';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {history} from "../../routes/Routing";
import Authentication from "../../authentication/Authentication";
import Footer from "../footer/Footer";
import PisaasInstanceInfo from "../instances/PisaasInstanceInfo";
import Nav from "../../nav/Nav";
import InstancesButtons from "../instances/InstancesButtons";
import Loading from "../loading/Loading";
import PisaasCustomerSignUpPopUp from "../instances/PisaasCustomerSignUpPopUp";

class Academy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            requestingPisaasCustomerInstances: false,
            pisaasCustomerInstances: [],
            showTryPisaasSection: true,
            packageId: 8
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.load();
        this.pisaasCustomerInstanceInterval = setInterval(this.pisaasCustomerInstancesRefresh, 10000);
    }

    componentWillUnmount() {
        if (this.pisaasCustomerInstanceInterval) {
            clearInterval(this.pisaasCustomerInstanceInterval);
        }
    };

    load = () => {
        this.setState({
            loading: true
        });

        const api = new Api();

        api.pisaasFetchCustomerInstances(this.setPisaasCustomerInstances, function (err) {
            console.log(err);
            toast.error("Failed to load your instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    };

    loadAfterCreate = () => {
        this.setState(
            {
                requestingPisaasCustomerInstances: true,
                loading: true
            });

        const api = new Api();

        setTimeout(function (successCallback) {
            api.pisaasFetchCustomerInstances(successCallback, function (err) {
                console.log(err);
                toast.error("Failed to load your instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }, 1000, this.setPisaasCustomerInstances)
    };

    pisaasCustomerInstancesRefresh = () => {
        const api = new Api();

        setTimeout(function (successCallback) {
            api.pisaasFetchCustomerInstances(successCallback, function (err) {
                console.log(err);
                toast.error("Failed to refresh running instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }, 1000, this.setPisaasCustomerInstancesMaintainRequesting);
    };

    setPisaasCustomerInstances = async (pisaasInstances) => {
        const api = new Api();

        const instancesWithData = await Promise.all(pisaasInstances.map(async (instance) => {
            const valuePromise = new Promise((resolve, reject) => {
                api.fetchServiceInfoByInstance(function (data) {
                    const instanceWithServiceInfo = {
                        ...instance,
                        "services": data[0]?.services
                    }
                    instanceWithServiceInfo["status"] = "pending"
                    resolve(instanceWithServiceInfo);
                }, function (err) {
                    toast.error("Failed to fetch schedeled jobs", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    reject(err);
                }, instance.domain, instance.region);
            })
            return valuePromise;
        }))

        this.setState(
            {
                pisaasCustomerInstances: instancesWithData,
                requestingPisaasCustomerInstances: false,
                loading: false
            });
    };

    setPisaasCustomerInstancesMaintainRequesting = async (pisaasInstances) => {
        const api = new Api();

        const instanceWithData = await Promise.all(pisaasInstances.map(async (instance) => {
            const valuePromise = new Promise((resolve, reject) => {
                api.fetchServiceInfoByInstance(function (data) {
                    const instanceWithServiceInfo = {
                        ...instance,
                        "services": data[0]?.services
                    }
                    instanceWithServiceInfo["status"] = "pending"
                    resolve(instanceWithServiceInfo);
                }, function (err) {
                    toast.error("Failed to fetch schedeled jobs", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    reject(err);
                }, instance.domain, instance.region);
            })
            return valuePromise;
        }))

        this.setState(
            {
                pisaasCustomerInstances: instanceWithData
            });
    }

    logout = () => {
        this.authentication.logout(function () {
            history.push('/');
        });
    };

    renderPisaasCustomerInstanceInfo = (pisaasCustomerInstances, requesting) => {
        if (!pisaasCustomerInstances || pisaasCustomerInstances.length === 0) {
            return (
                <>
                    {requesting ?
                        <div className={"loading-container"}  data-testid="academy.loading.container">
                            Requesting. This can take up to a minute.
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            <span className="sr-only" data-testid="academy.loading.text">Requesting. This can take up to a minute.</span>
                        </div>
                        :
                        <></>
                    }
                </>
            );
        } else {
            return (
                <div>
                    {requesting ?
                        <div className={"loading-container"} data-testid="academy.loading.container">
                            Requesting. This can take up to a minute.
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            <span className="sr-only" data-testid="academy.loading.text">Requesting. This can take up to a minute.</span>
                        </div>
                        : null}
                    {pisaasCustomerInstances.map((pisaasInstance) => pisaasInstance.package_id === 8 && pisaasInstance.latest_billing_package_id !== 5 ?
                        <PisaasInstanceInfo isAdmin={this.authentication.isAdmin()} refreshPisaasInstances={this.pisaasCustomerInstancesRefresh} piSaasInstance={pisaasInstance} key={pisaasInstance.pisaas_instance_id}/>
                        : <></>)}
                </div>
            )
        }
    };

    successCallback = () => {
        this.loadAfterCreate()
    }

    handleSignUp = () => {
        this.setState({
                loading: true,
                requestingPisaasCustomerInstances: true
            }
        )
        const {packageId} = this.state;

        const api = new Api();

        api.pisaasUserSignup(this.successCallback, function(err) {
            console.log(err);
            toast.error("Failed to buy package", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, packageId);

    }

    allowCreation = () => {
        const trypiPackageId = 8;
        const activeInstances = this.state.pisaasCustomerInstances.filter(instance => instance["package_id"] === trypiPackageId)
        const hasActivePackage = activeInstances.filter(instance => instance["latest_billing_package_id"] === trypiPackageId).length >= 1
        return !hasActivePackage;
    };


    render() {
        return (
            <div className={"instances-container"} data-testid="academy.instances.container">
                <Nav history={this.props.history}/>
                <div className={"instances-header gap-bottom-5"}>
                    <h1 className={"instances-heading"} data-testid="academy.instances.heading">Enjoy your learn time.</h1>
                    <InstancesButtons loading={this.state.loading} logout={this.logout} load={this.load}
                                      requestingTryPi={this.state.requestingPisaasCustomerInstances}
                                      allowCreation={this.allowCreation()}
                                      createTryPiInstance={true}
                                      handleSignUp={this.handleSignUp}
                                      createHasBeenClicked={this.state.createHasBeenClicked}
                    />

                </div>
                <div className="play-info" data-testid="academy.playInfo">
                    <h2>Play with pi instances:</h2>
                    <ul>
                        <li>Click create to start your Academy instance</li>
                        <li>The launch button will become available after around 5 minutes when the dashboard has started up</li>
                        <li>After 5 minutes, you may need to refresh to retrieve status updates</li>
                        <li>You will have access to your instance for 22 hours, after which your environment will be removed</li>
                        <li>You will need to create a new instance if you wish to learn after 22 hours</li>
                    </ul>
                </div>
                {this.state.loading ? <Loading/> : this.state.showTryPisaasSection ? this.renderPisaasCustomerInstanceInfo(this.state.pisaasCustomerInstances, this.state.requestingPisaasCustomerInstances) : <></>}
                {this.state.showPisaasCustomerSignUp ? <PisaasCustomerSignUpPopUp togglePopUp={this.togglePisaasCustomerCreatePopUp} loadAfterCreate={this.loadAfterCreate}/> : <></>}
                <Footer/>
            </div>
        );
    }
}

export default Academy;